export enum ExportStatusType {
  TaskExport = 'TASK_LIST_EXPORT',
  ProjectExport = 'PROJECT_LIST_EXPORT',
}
export interface FilterBy {
  match: string | null;
  projectId?: number;
  [key: string]: unknown;
}
export interface ExportRequest {
  filterBy: FilterBy;
  columnOrder?: string[];
}
export interface StatusMeta {
  request: ExportRequest;
}
export interface ExportPayload {
  statusType: ExportStatusType;
  statusMeta: StatusMeta;
}
export enum ExportQueueStatus {
  Submitted = 'SUBMITTED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}
export interface ExportResponse {
  statusId: number;
  createdAt: number;
  status: ExportQueueStatus;
  statusMeta: StatusMeta;
}
